/**
 * ヘルプの一覧と本文（`/help`・`/help/*`）。中身は共通パッケージの
 * `createHelpPage` で、ここでは見出しの横に、このページ自身の説明を置く。
 */

import { HelpIcon, HelpPage as SharedHelpPage } from "../help/index";

export function HelpPage() {
  return <SharedHelpPage titleExtra={<HelpIcon slug="help/about" />} />;
}
